import React, { useState, useEffect } from "react";
import { UploadCloudIcon, BriefcaseIcon, FolderIcon, ProjectIcon, IssueTriangleAlert, MilestoneIcon, RiskIcon} from "../../modules/default-svg";
import { isValidEmail } from "../../utils/formValidation";
import { Accordion, AccordionHeader, AccordionItem, AccordionPanel} from "@fluentui/react-components";
import InputUnderline from "../../components/controls/input/InputUnderline";
import Modal from "../../components/controls/modal/Modal";
import Button from '../../components/controls/button';
import deletionRequestService from "../../store/services/deletionRequest.service";
import { useDispatch } from "react-redux";
import { generalActions } from "../../store/actions";
import Style from "./DeleteRequest.module.scss"

export default function DeleteRequest({ data, handleCancel, handleRefresh }) {
const user = JSON.parse(localStorage.getItem('user'));
const PUBLIC_URL = process.env.PUBLIC_URL;
const dispatch = useDispatch();
const [requestDeleteData, setRequestDeleteData] = useState(data);
const [deleteRequestEmail, setDeleteRequestEmail] = useState(user.email);
const [deleteRequestEmailError, setDeleteRequestEmailError] = useState("");
const [isDeleteRequestLoading, setIsDeleteRequestLoading] = useState(false);
const [isDeleteRequestCreated, setIsDeleteRequestCreated] = useState(false);

const handleCancelDeleteRequest = () => {
    setRequestDeleteData({});
    handleCancel(false);
  };

const handleDeleteRequest = () => {
    if(!isValidEmail(deleteRequestEmail)){
      setDeleteRequestEmailError("Invalid Email");
      return;
    }
  
      var deletionRequestCreationDto = 
      {
        refId: requestDeleteData.reference.id,
        refType: requestDeleteData.reference.type,
        Email: deleteRequestEmail
      };
      setIsDeleteRequestLoading(true);

      deletionRequestService.createDeletionRequest(deletionRequestCreationDto)
                  .then(() => {
                      setIsDeleteRequestLoading(false);
                      setIsDeleteRequestCreated(true);
                      handleRefresh();
                  })
                  .catch(() => {
                    setIsDeleteRequestLoading(false);
                      dispatch(
                              generalActions.showToast({
                                  title: "Something went wrong. Please try again later.",
                                  type: "error",
                              })
                              );
                  });
}
const handleDeleteRequestEmailChange = (email) =>{
    setDeleteRequestEmail(email);
    setDeleteRequestEmailError("")
  }

const validateDeleteRequestEmail = (e) => {
var result = isValidEmail(e.target.value);
setDeleteRequestEmailError(!result?"Invalid Email":"")
return result;
}

const handleRedirection = (type, item) => {
    switch (type) {
      case "Portfolio": {
        window.open(`${PUBLIC_URL}/portfolio/${item.id}/overview`, '_blank');
        break;
      }
      case "Program": {
        window.open(`${PUBLIC_URL}/program/${item.id}/overview`, '_blank');
        break;
      }
      case "Project": {
        window.open(`${PUBLIC_URL}/projects/${item.id}/overview`, '_blank');
        break;
      }
      case "Scope": {
        window.open(`${PUBLIC_URL}/scopes/${item.id}/overview`, '_blank');
        break;
      }
      default:
        return "";
    }
  };

  const getRefEntityNamebyType = (type) =>{

    switch(type){
      case 0: {return "Client";}
      case 1: {return "Portfolio";}
      case 2: {return "Program";}
      case 3: {return "Project";}
    }
  };

  return(

        <Modal
          title={`Deletion Request - ${requestDeleteData.reference.name}`}
          body={
            
              !isDeleteRequestCreated ?
              (
            <div className="m-2">
              <p className="text-sm-400 subHeading-color">
              The {getRefEntityNamebyType(requestDeleteData.reference.type)} you are about to delete is associated with the following entities. <br />Please review them carefully, as deleting this {getRefEntityNamebyType(requestDeleteData.reference.type)} will also impact the related data listed below
              </p>
              <div className="flex row mx-2 my-10">
                <Accordion collapsible multiple>
                  <div>
                    {
                      ((requestDeleteData?.portfolios && requestDeleteData?.portfolios?.length > 0) &&
                      (<AccordionItem className={Style.accordionItem} value="1">
                        <AccordionHeader className={Style.accordionHeader}  icon={<BriefcaseIcon />}>Portfolios <span className="pill purple m-2">{requestDeleteData.portfolios.length}</span></AccordionHeader>
                        {requestDeleteData.portfolios.map(
                                  (item) => (
                                    <AccordionPanel>
                                      <p
                                        className={`text-md-400 grey10Color entityName px-5 py-2`}
                                        onClick={() =>handleRedirection("Portfolio", item)}
                                      >
                                        {item.name}
                                      </p>
                                    </AccordionPanel>
                                  )
                                )}
                    </AccordionItem>
                    ))
                    }
                  </div>
                  <div>
                    {
                       ((requestDeleteData?.programs && requestDeleteData?.programs?.length > 0) &&
                       (<AccordionItem className={Style.accordionItem} value="2">
                         <AccordionHeader className={Style.accordionHeader} icon={<FolderIcon />}>Programs <span className="pill purple m-2">{requestDeleteData.programs.length}</span></AccordionHeader>
                         {requestDeleteData.programs.map(
                                   (item) => (
                                    <AccordionPanel>
                                      <p
                                        className={`text-md-400 grey10Color entityName px-5 py-2`}
                                        onClick={() =>handleRedirection("Program", item)}
                                      >
                                        {item.name}
                                      </p>
                                  </AccordionPanel>
                                   )
                                 )}
                     </AccordionItem>
                     ))
                    }
                  </div>
                  <div>
                  {
                    ((requestDeleteData?.projects && requestDeleteData?.projects?.length > 0) &&
                      (<AccordionItem className={Style.accordionItem} value="3">
                        <AccordionHeader className={Style.accordionHeader} icon={<ProjectIcon />}>Projects <span className="pill purple m-2">{requestDeleteData.projects.length}</span></AccordionHeader>
                        {requestDeleteData.projects.map(
                                  (item) => (
                                    <AccordionPanel>
                                      <p
                                        className={`text-md-400 grey10Color entityName px-5 py-2`}
                                        onClick={() =>handleRedirection("Project", item)}
                                      >
                                        {item.name} <span className="pill blue m-2">Scope Items: {item.scopesCount}</span>
                                      </p>
                                    </AccordionPanel>
                                  )
                                )}
                    </AccordionItem>
                    ))
                  }
                  </div>
                  <div>
                  {
                    ((requestDeleteData?.scopes && requestDeleteData?.scopes?.length > 0) &&
                      (<AccordionItem className={Style.accordionItem} value="4">
                        <AccordionHeader className={Style.accordionHeader} icon={<MilestoneIcon />}>Scopes <span className="pill purple m-2">{requestDeleteData.scopes.length}</span></AccordionHeader>
                        {requestDeleteData.scopes.map(
                                  (item) => (
                                    <AccordionPanel>
                                      <p
                                        className={`text-md-400 grey10Color entityName px-5 py-2`}
                                        onClick={() =>handleRedirection("Scope", item)}
                                      >
                                        {item.name} <span className="pill blue m-2">Tasks: {item.tasksCount}</span>
                                      </p>
                                    </AccordionPanel>
                                  )
                                )}
                    </AccordionItem>
                    ))
                  }
                  </div>
                  <div>
                  {
                    ((requestDeleteData?.risks && requestDeleteData?.risks?.length > 0) &&
                      (<AccordionItem className={Style.accordionItem} value="5">
                        <AccordionHeader className={Style.accordionHeader} icon={<RiskIcon />}>Risks/Issues <span className="pill purple m-2">{requestDeleteData.risks.length}</span></AccordionHeader>
                        {requestDeleteData.risks.map(
                                  (item) => (
                                    <AccordionPanel>
                                      
                                      <div
                                        className={`text-md-400 grey10Color px-5 py-2 gap-1`}
                                        style={{display: "inline-flex", alignItems: "center", color:item.isIssue ? "#c50f1f" : ""}}
                                      >
                                        {item.isIssue && <IssueTriangleAlert className/>}{item.name}
                                      </div>
                                    </AccordionPanel>
                                  )
                                )}
                    </AccordionItem>
                    ))
                  }
                  </div>
                </Accordion>
              </div>
              <div className="row justify-content-center">
                <div className="col-12 mb-1">
                  <p className="text-sm-400 subHeading-color">
                  A confirmation email will be sent to your registered address below
                  </p>
                </div>
              
                <div className="col-8">
                  <InputUnderline
                    inputUnderlinewd="w-80"
                    isRequired
                    placeholder="Email"
                    value={deleteRequestEmail}
                    handleBlur={validateDeleteRequestEmail}
                    handleChange={handleDeleteRequestEmailChange}
                    error={deleteRequestEmailError}
                  />
                </div>
              </div>
              
            </div>
              )
              :
              (
              <div className="m-2">
                <div>
                  <div className="mx-8 my-10">
                    <div className="mb-5">
                      <p className="text-center mb-2 text-xl-700">Confirmation Email Sent</p>
                      <p className="text-center text-[#808D9E] text-sm-500">We've sent a confirmation link to your registered email address. <br/> Please check your inbox and follow the instructions to complete the deletion process.</p>
                    </div>
                  </div>
                  <div className="pt-0 px-8 pb-8">
                  <p className="text-[#808D9E] text-sm-500 mb-1">Didn't receive the email?</p>
                    <Button btnClass="btn_w100 btn_w100_primary text-sm-500" label="Resend Confirmation" clickHandler={() =>{}} />
                    {/* <div
                      className="d-flex align-items-center"
                      onClick={handleBack}
                    >
                      <ArrowLeft />
                      <p className="my-3 text-xsm-500 text-[#5e5e5e] hover:text-[#342c82] hover:cursor-pointer">
                          Back to Sign In
                      </p>
                    </div> */}
                  </div>
                </div>                 
              </div>
              )
            
            
          }
          footer = {!isDeleteRequestCreated}
          handleCancel={() => handleCancelDeleteRequest()}
          handleSave={() => handleDeleteRequest()}
          saveBtnLabel="Submit Request"
          isSaveBtnDisabled= {deleteRequestEmailError != ""}
          cancelBtnLabel="Cancel"
          isLoading={isDeleteRequestLoading}
        />
  );
};